import type { IconSvgProps } from 'src/components/common/Icons/types';

export const IconCertifiedSvg = ({
  title,
  titleId,
  ...props
}: IconSvgProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 60.83 67.58"
    focusable="false"
    fill={props.color || 'currentColor'}
    width={16}
    height={17}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : <title>Verified Icon</title>}{' '}
    <g>
      <path
        fill="none"
        d="M30.42,0a8.69,8.69,0,0,0-4.31,1.15L4.3,13.74A8.65,8.65,0,0,0,0,21.2V46.38a8.63,8.63,0,0,0,4.3,7.45L26.11,66.42a8.57,8.57,0,0,0,8.61,0L56.53,53.83a8.63,8.63,0,0,0,4.3-7.45V21.2a8.65,8.65,0,0,0-4.3-7.46L34.72,1.15A8.68,8.68,0,0,0,30.42,0Z"
      />
      <path d="M26.83,47.71a.38.38,0,0,1-.29-.09L16,38.85a1.38,1.38,0,0,1-.47-1V28.5a.3.3,0,0,1,.48-.26l10.85,9L52.4,16,32.72,4.61a4.63,4.63,0,0,0-4.61,0L6.3,17.21a4.59,4.59,0,0,0-2.3,4V46.38a4.59,4.59,0,0,0,2.3,4L28.11,63a4.63,4.63,0,0,0,4.61,0l21.81-12.6a4.59,4.59,0,0,0,2.3-4V22.9L27.11,47.62A.37.37,0,0,1,26.83,47.71Z" />
    </g>
  </svg>
);
